// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row {
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;
}

.organisation-select {
  width: 40%;
}

.comboLabel {
  width: 9%;
}

.success-message {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  color: var(--theme-main-color, #055C8D);
  font-weight: 450;
  height: 36px;
  margin-left: -5px;
}

.reload-instruction {
  font-size: 13px;
  font-weight: 410;
  color: var(--theme-main-color, #055C8D);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
